export default __webpack_public_path__ + "static/media/support_submitted.e6138310.svg";